module.exports = __webpack_public_path__ + "img/catering_menu_6.28bbea8f.jpg";